module.exports = __webpack_public_path__ + "static/media/new.11fac104.png";